import { render, staticRenderFns } from "./AIcopyDrawer.vue?vue&type=template&id=4c22520c&scoped=true"
import script from "./AIcopyDrawer.vue?vue&type=script&lang=js"
export * from "./AIcopyDrawer.vue?vue&type=script&lang=js"
import style0 from "./AIcopyDrawer.vue?vue&type=style&index=0&id=4c22520c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c22520c",
  null
  
)

export default component.exports